import React from 'react';
import { Box, Paper } from '@mui/material';
import PatientInfoCard from './patientInfoCard';
import PatientHistoryInfo from './patientHistoryInfo';
import ReportTable from './reportTable';
import StimulationProtocolTable from './stimulationProtocolTable';
import SourceTable from './sourceTable';
import { useSelector } from 'react-redux';
import {
  checkFileAvailabilityApi,
  createPatientOPUPdfApi,
} from '../../../../api/patientApi';
import { pollFileAvailability } from '../../../../api/utils';
import { toast } from 'sonner';
import axios from 'axios';

export default function OpuSheet() {
  const patientDetails = useSelector(
    (state) => state.clinicalReducer.patientDetails,
  );
  const selectedPatientData = useSelector(
    (state) => state.clinicalReducer.selectedPatientData,
  );
  const infertilityDetails = useSelector(
    (state) => state.clinicalReducer.infertilityDetails,
  );
  const patientHistory = useSelector(
    (state) => state.clinicalReducer.patientHistory,
  );
  const examinationOfMalePartner = useSelector(
    (state) => state.clinicalReducer.examinationOfMalePartner,
  );
  const treatmentPlan = useSelector(
    (state) => state.clinicalReducer.treatmentPlan,
  );
  const investigationOfFemalePartner = useSelector(
    (state) => state.clinicalReducer.investigationOfFemalePartner,
  );
  const treatmentPlanForm = useSelector(
    (state) => state.clinicalReducer.currentCycle.fmsData.treatmentPlanForm,
  );
  const fmsData = useSelector(
    (state) => state.clinicalReducer.currentCycle.fmsData,
  );
  const fetData = useSelector(
    (state) => state.clinicalReducer.currentCycle.fetSheet,
  );

  const handleSheetDownload = async () => {
    try {
      const opuSheetParams = {
        patientDetails,
        selectedPatientData,
        infertilityDetails,
        patientHistory,
        examinationOfMalePartner,
        treatmentPlan,
        investigationOfFemalePartner,
        treatmentPlanForm,
        fmsData,
        fetData,
      };
      const response = await createPatientOPUPdfApi(
        selectedPatientData.patient.id,
        opuSheetParams,
      );
      toast.success('OPU sheet will be downloaded shortly');
      const bucketName = response.data.pdf.output_bucket_name;
      const key = response.data.pdf.output_key;
      try {
        const presignedUrl = await pollFileAvailability(
          checkFileAvailabilityApi,
          bucketName,
          key,
        );
        downloadFile(presignedUrl, selectedPatientData.patient.id);
      } catch (error) {
        console.error('Failed to get presigned URL:', error);
      }
    } catch (error) {
      console.error('Failed to download OPU sheet:', error);
    }
  };

  const downloadFile = async (presignedUrl, patientId) => {
    try {
      const response = await axios.get(presignedUrl, {
        responseType: 'blob',
      });
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `${patientId}-opu-sheet.pdf`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error('Error downloading the file', error);
    }
  };

  return (
    <Box
      sx={{ width: '100%', display: 'flex', flexDirection: 'column', gap: 4 }}
    >
      <div
        className="cycle-header"
        style={{
          margin: '10px 10px 0px 0px',
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'center',
        }}
      >
        <h2 style={{ textDecoration: 'underline' }}>
          {' '}
          OPU - Patient Information Sheet{' '}
        </h2>
      </div>
      <PatientInfoCard />
      <PatientHistoryInfo />
      <SourceTable />
      <ReportTable />
      <StimulationProtocolTable />
      <div
        style={{
          width: '100%',
          mb: 2,
          justifyContent: 'center',
          display: 'flex',
          marginBottom: 20,
        }}
      >
        <button
          className="btn btn-primary"
          style={{ margin: '10px 10px 0px 0px' }}
          onClick={handleSheetDownload}
        >
          Download
        </button>
      </div>
    </Box>
  );
}
